import { Environment, getEnvironment } from './environmentService'

const getUrl = (environment: Environment): string => {
  switch (environment) {
    case Environment.Local:
      return 'https://' + window.location.hostname + ':5001/'
    case Environment.Int:
      return 'https://solar360.int.igssolarpower.com/'
    case Environment.Dev:
      return 'https://solar360.dev.igssolarpower.com/'
    case Environment.Qa:
      return 'https://solar360.qa.igssolarpower.com/'
    case Environment.Prod:
      return 'https://solar360.igssolarpower.com/'
    case Environment.Con2:
        return 'https://solar360.con2.igssolarpower.com/'
    case Environment.Con3:
        return 'https://solar360.con3.igssolarpower.com/'
    default:
      return ''
  }
}

export const getBaseUrl = (): string => getUrl(getEnvironment())

export const getAngularBaseUrl = (): string => `${getBaseUrl()}/#/`
